// sagas/index.js
import { all } from 'redux-saga/effects';
import dataFileSaga from './dataFileSaga'; // Import your API saga
import watchLogin from './authSaga';
import { watchFetchBlogs } from './blogSaga';
import watchFetchOrders from './orderSaga';

export default function* rootSaga() {
  yield all([
    dataFileSaga(), // Add your API saga here
    watchLogin(),
    watchFetchBlogs(),
    watchFetchOrders()
  ]);
}
